import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SpecialtyItemProps } from "apis/specialty";
import { PaginationProps } from "utils/types/API";

export interface SpecialtyState {
    loading: boolean;
    list: {
        data: SpecialtyItemProps[];
        options: SpecialtyItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: SpecialtyItemProps;
    };
}

const initialState: SpecialtyState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: SpecialtyItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: SpecialtyItemProps;
}
export const specialtySlice = createSlice({
    name: "specialty",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = specialtySlice.actions;
export default specialtySlice.reducer;
